import { auth } from "lib/firebase"
import { sendPasswordResetEmail } from 'firebase/auth';
import { paths } from 'routes';
import { API_URL } from 'configuration';

export const forgotPassword = async (email) => {
  await sendPasswordResetEmail(auth, email, { url: `${API_URL}${paths.auth.login}` });
}
